import { Component, OnInit, Input, HostListener, ViewChild, ElementRef } from '@angular/core';
import { TitleConfigurations, TitleLineConfigurations } from "../title/title.configurations";
import { KlaHttpService } from "../services/kla.http.service";
import { BubbleGraphConfiguration } from "./indicator-bubble-graph.configuration";
import { CommonModule } from '@angular/common';
import { BubbleChartComponent } from 'app/shared/charts/bubble-chart/bubble-chart.component';
import { TitleComponent } from '../title/title.component';
import { SafeHtmlPipe } from '../safe-html/safe-html';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-indicator-bubble-graph',
  templateUrl: './indicator-bubble-graph.component.html',
  styleUrls: ['./indicator-bubble-graph.component.scss'],
  standalone: true,
  imports: [ CommonModule, BubbleChartComponent, TitleComponent, DynamicContentComponent ]
})
export class IndicatorBubbleGraphComponent implements OnInit {

  @ViewChild('panel', {static: true})
  public panel:ElementRef;

  @Input()
  public config: {
    image:string,
    title: TitleConfigurations,
    chartId: string
  };

  @Input()
  public lineConfig: TitleLineConfigurations;

  public graphConfig = <BubbleGraphConfiguration> {};

  public chartConfig: any;

  public showChart: boolean = false;

  constructor(private httpService: KlaHttpService) { }

  ngOnInit() {
    this.chartConfig = {
      height: 500,
      width: 600,
      data: [
        { id: "root", parentId: "", color: "white", size: undefined }
      ]
    }
    this.findChartData();
  }

  private findChartData() {
    this.httpService.getChartData("kla-bubble-chart", this.config.chartId).subscribe(
      (data) => {
        this.graphConfig.data = data;
        if (!this.graphConfig.data) {
          console.error("Please provide bar chart configurations");
        } else {
          this.setGraphData();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  setGraphData(){
    this.graphConfig.data.sort((n1,n2)=> n2.size - n1.size);

    this.graphConfig.data.forEach(element => {
      this.chartConfig.data.push({
        id:"",
        parentId: "root",
        label: element.label,
        color: element.color,
        image: this.httpService.getImagePath(element.image, 500),
        size: element.size
      });
    })
    this.showChart = true;
    this.onResize();
  }

  @HostListener('window:resize')
  onResize() {
    this.resize();
  }
  private resize() {
    let rectangle = this.panel.nativeElement.getBoundingClientRect();
    if(rectangle.width > 650 ){
      this.chartConfig.width = 600;
    }
    else if(rectangle.width > 600 ){
      this.chartConfig.width = 550;
    }
    else if(rectangle.width < 550 ){
      this.chartConfig.width = 500;
    }
 
  }

}
